import React, { useState } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import "./style.css";

import { signup, add, googleSignup } from "firebase_config";
import { StaticHeaderComponent } from "components";
import { validateEmail, convertToSnakeCase, isIosDevice } from "helpers";
import { Tables, Routes } from "constants/index";
import { post } from "services";

const SignupComponent = (props) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tnc, setTnc] = useState(false);
  const [emailUpdates, setEmailUpdates] = useState(true);
  const [btnSave, setBtnSave] = useState("Submit");
  const [error, setErrors] = useState("");
  const [eyeIcon, setEyeIcon] = useState("fa-eye");
  const history = useHistory();
  const inviteeUsername = props.match.params.username;
  const isIOS = isIosDevice();

  const handleForm = async (e) => {
    setErrors("");
    e.preventDefault();
    if (!username || !username.trim()) {
      setErrors("Name is mandatory");
      return null;
    }
    if (username && !username.match("^[a-z 0-9 _]+$")) {
      setErrors("Only alphanumeric values are accepted as username");
      return null;
    }

    const data = {
      username: username.toLowerCase().replace(/ /g, "_"),
      displayName: username,
    };
    if (!email || !email.trim()) {
      setErrors("Email is mandatory");
      return null;
    }
    if (email && !validateEmail(email)) {
      setErrors("Enter a valid email");
      return null;
    }
    if (!password || !password.trim()) {
      setErrors("Password is mandatory");
      return null;
    }
    if (password && password.trim().length < 9) {
      setErrors("Password must have atleast 8 characters");
      return null;
    }
    if (!tnc) {
      setErrors("Agree to our Terms and conditions");
      return null;
    }
    setBtnSave("Submitting...");
    const res = await signup({ email, password, data });
    if (res && res.status !== 200) {
      setErrors(res.message);
      setBtnSave("Submit");
      return null;
    }
    const userData = {
      email: email.toLowerCase().trim(),
      username: data.username,
      displayName: data.displayName,
      permissions: {
        tnc,
        recordPageVisits: true,
        locationAccess: true,
        emailUpdates,
      },
      photoURL: null,
      depositAmount: 0,
      withdrawAmount: 0,
      roles: ["user"],
      emailVerified: true,
      verifyEmailSentTime: new Date(),
    };
    const createDbUser = await add("users", userData);

    if (inviteeUsername) {
      /* Invited by a user */
      await add("referals", {
        username: data.username,
        invitedBy: inviteeUsername,
      });
    }
    setBtnSave("Submit");
    if (createDbUser.status !== 200) {
      setErrors(createDbUser.message);
      return null;
    } else {
      post("/send_email", {
        sender: "naga",
        templateName: "welcome_new_user.html",
        email,
        subject: "Welcome to Medoc",
        displayName: data.displayName,
      });
    }
    history.replace("/app/posts");
  };

  const showPassword = () => {
    const input = document.getElementById("signupPass");
    if (input.type === "password") {
      setEyeIcon("fa-eye-slash");
      input.type = "text";
    } else {
      setEyeIcon("fa-eye");
      input.type = "password";
    }
  };

  const handleGoogleSignup = async () => {
    const res = await googleSignup();

    if (res?.data?.additionalUserInfo?.isNewUser) {
      const userData = {
        email: res.data.email,
        username: convertToSnakeCase(res.data.displayName),
        displayName: res.data.displayName,
        permissions: {
          tnc: true,
          recordPageVisits: true,
          locationAccess: true,
          emailUpdates: true,
        },
        photoURL: null,
        depositAmount: 0,
        withdrawAmount: 0,
        roles: ["user"],
        emailVerified: true,
      };
      const createDbUser = await add(Tables.USERS, userData);

      if (inviteeUsername) {
        /* Invited by a user */
        await add(Tables.REFERRALS, {
          username: userData.username,
          invitedBy: inviteeUsername,
        });
      }
      setBtnSave("Submit");
      if (createDbUser.status !== 200) {
        setErrors(createDbUser.message);
        return null;
      } else {
        post("/send_email", {
          sender: "naga",
          templateName: "welcome_new_user.html",
          email: res.data.email,
          subject: "Welcome to Medoc",
          displayName: res.data.displayName,
        });
      }
    }
    history.replace("/");
  };

  return (
    <div className="signup-page" id="signup">
      <StaticHeaderComponent bottomFooter="false" />
      <div className="container login-form">
        <div className="d-flex justify-content-center my-5 py-5">
          <div className="col-12 order-1 order-md-2 col-sm-6 right-block">
            <div className="body">
              <p className="h6 mt-5 mb-3">Sign up</p>
              {error && (
                <div className="text-danger text-center my-3 fw-500">
                  {error}
                </div>
              )}
              <div className="input-group mb-2">
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value.toLowerCase())}
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  autoFocus={true}
                  aria-label="name"
                />
              </div>
              <div className="input-group mb-2">
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  aria-label="email"
                  aria-describedby="basic-addon1"
                />
              </div>
              <div className="input-group mb-2">
                <input
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  value={password}
                  type="password"
                  className="form-control"
                  id="signupPass"
                  placeholder="Password (atleast 8 letters required)"
                  aria-label="password"
                  aria-describedby="basic-addon2"
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text append"
                    id="basic-addon3"
                    onClick={(e) => showPassword()}
                  >
                    {eyeIcon === "fa-eye" ? (
                      <img
                        className="show-password"
                        src={require("assets/svgs/Eye.svg").default}
                        alt="Eye"
                      />
                    ) : (
                      <img
                        className="show-password"
                        src={require("assets/svgs/EyeOpen.svg").default}
                        alt="EyeOpen"
                      />
                    )}
                  </span>
                </div>
              </div>
              <div className="options pt-2">
                <div className="d-flex align-items-center form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="tnc"
                    name="tnc"
                    onChange={(e) => setTnc(!tnc)}
                    checked={tnc}
                  />
                  <label className="form-check-label" htmlFor="tnc">
                    I accept our{" "}
                    <a
                      href={Routes.TNC}
                      className="text-violet"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of service
                    </a>{" "}
                    and{" "}
                    <a
                      href={Routes.PRIVACY_POLICY}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-violet"
                    >
                      Privacy policy
                    </a>
                    .
                  </label>
                </div>
                <div className="d-flex form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="emailUpdates"
                    name="emailUpdates"
                    onChange={(e) => setEmailUpdates(!emailUpdates)}
                    checked={emailUpdates}
                  />
                  <label className="form-check-label" htmlFor="emailUpdates">
                    I'd like to be notified by email.
                  </label>
                </div>
              </div>
              <div>
                <button
                  className="btn login-btn col-12"
                  disabled={btnSave !== "Submit"}
                  onClick={(e) => handleForm(e)}
                >
                  {btnSave}
                </button>
                <br />
                <Link to="/login" className="text-violet">
                  Already a user? Log in
                </Link>
                <br />
                <div className={`${isIOS && "d-none"}`}>
                  <div className="mt-4 mb-3 separator">OR</div>
                  <button
                    className="btn google-login-btn col-12 align-items-center"
                    onClick={handleGoogleSignup}
                  >
                    <i className="fa fa-google"></i> &nbsp;{" "}
                    <span className="fw-500">Signup with Google</span>
                  </button>
                  <div className="caption-text font-small fw-500 d-none">
                    By Signing up, you are agreeing to our
                    <a
                      href="/tnc"
                      className="text-violet pl-1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of service
                    </a>
                    , and our{" "}
                    <a
                      href="/privacy_policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-violet"
                    >
                      Privacy policy
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SignupComponent);
